import { render, staticRenderFns } from "./PContainer.vue?vue&type=template&id=c44380e4&scoped=true&"
import script from "./PContainer.vue?vue&type=script&lang=js&"
export * from "./PContainer.vue?vue&type=script&lang=js&"
import style0 from "./PContainer.vue?vue&type=style&index=0&id=c44380e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c44380e4",
  null
  
)

export default component.exports